import store from "store";

const USER_SESSION = "user_session_token";
const OTP_VERIFICATION = "user_otp_verification_obj";
const ADD_HOME_SCREEN_PRESSED = "home_screen_pop_up_close";
const USER_DATA = "@user";

/**
 * Save a piece of data to local storage
 *
 * @param {String} name
 * @param {Any} value
 */
function setLocalStorage(name, value) {
  store.set(name, value);
}

/**
 * Retrieve a piece of data from local storage
 *
 * @param {String} name
 */
function getLocalStorage(name) {
  return store.get(name);
}

/**
 * Remove local storage
 *
 * @param {String} name
 */
function removeLocalStorageItem(name) {
  return store.remove(name);
}

/**
 * Set User Session
 *
 * @param {Object} data
 */
function setUserSession(data) {
  setLocalStorage(USER_SESSION, data);
}

/**
 * Get User Session
 *
 * @return {Object}
 */
function getUserSession() {
  return getLocalStorage(USER_SESSION);
}

/**
 * Clear User Session
 */
function clearUserSession() {
  setLocalStorage(USER_SESSION, null);
}

/**
 * Set User Session
 *
 * @param {Object} data
 */
function setUserOTPObj(data) {
  setLocalStorage(OTP_VERIFICATION, JSON.stringify(data));
}

/**
 * Get User Session
 *
 * @return {Object}
 */
function getUserOTPObj() {
  return JSON.parse(getLocalStorage(OTP_VERIFICATION));
}

/**
 * Clear User Session
 */
function clearUserOTPObj() {
  setLocalStorage(OTP_VERIFICATION, null);
}

/**
 * Set home btn
 *
 * @param {Object} data
 */
function setHomeScreen_Btn_pressed() {
  setLocalStorage(ADD_HOME_SCREEN_PRESSED, true);
}

/**
 * Get home btn
 *
 * @return {Object}
 */
function getHomeScreen_Btn_pressed() {
  return getLocalStorage(ADD_HOME_SCREEN_PRESSED);
}

/**
 * Clear home btn
 */
function clearHomeScreen_Btn_pressed() {
  setLocalStorage(ADD_HOME_SCREEN_PRESSED, false);
}

/**
 * Get user data
 */
function getUserData() {
  return JSON.parse(getLocalStorage(USER_DATA));
}

/**
 * Set user data
 */
function setUserData(data) {
  setLocalStorage(USER_DATA, JSON.stringify(data));
}

/**
 * Clear user data
 */
function clearUserData() {
  setLocalStorage(USER_DATA, null);
}

export {
  setLocalStorage,
  getLocalStorage,
  setUserSession,
  getUserSession,
  clearUserSession,
  removeLocalStorageItem,
  setUserOTPObj,
  getUserOTPObj,
  clearUserOTPObj,
  setHomeScreen_Btn_pressed,
  getHomeScreen_Btn_pressed,
  clearHomeScreen_Btn_pressed,
  getUserData,
  setUserData,
  clearUserData,
};
